import { IconButton, Tooltip } from "@mui/material";
import { SlPuzzle } from "react-icons/sl";

const ExtensionOptionsButton = ({ setShowExtensionModal }) => {
    function handleClick() {
        setShowExtensionModal(true);
    }
    return (
        <div>
            <Tooltip title="Extension Options">
                <IconButton aria-label="miningToken" component="label" onClick={handleClick}>
                    <SlPuzzle id="extension-icon" />
                </IconButton>
            </Tooltip>
        </div>
    );
}

export default ExtensionOptionsButton;